<template>
    <div class="overlay">
        <div class="overlay_inner settings">
            <p class="note">{{ name }}</p>
            <select-box id="popup-timeshift"
                        v-model="timeshift"
                        :options="nonLinearOptions"
            ><translate class="translate">Timeshift</translate>
            </select-box>
            <select-box id="popup-pvr"
                        v-model="pvr"
                        :options="nonLinearOptions"
            ><translate class="translate">PVR</translate></select-box>
          <select-box id="popup-periodic-pvr"
                      v-model="periodicPvr"
                      :options="nonLinearOptions"
          ><translate class="translate">Pravidelné nahrávky</translate></select-box>
            <select-box id="popup-catchup"
                        v-model="catchup"
                        :options="nonLinearOptions"
            ><translate class="translate">Catchup</translate></select-box>
            <text-input id="popup-catchup-hours"
                        :disabled="catchupHoursDisabled"
                        v-model="catchupHours"
                        ref="popupcatchuphoursref"
            ><translate class="translate">Počet hodin catchupu</translate>
            </text-input>
            <p class="buttons">
                <a class="btn" @click.stop.prevent="emitAction" v-translate>Uložit</a>
            </p>
            <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose" v-translate>Zavřít</a>
        </div>
    </div>
</template>

<script>
    import requiredFields from "@/components/mixins/required-fields"
	import {getCorrectBooleanValue} from "@/utils/helpers"

	export default {
		name: "ServiceSettingsPopup",
        mixins: [requiredFields],
		props: {
			popupData: Object,
			nonLinearOptions: Array,
		},
		computed: {
			name() {
				return this.popupData.name
			},
            catchupHoursDisabled() {
				return this.catchup !== true
            },
			catchup: {
				get() {
					return this.popupData.catchup
				},
				set(newValue) {
					this.popupData.catchup = getCorrectBooleanValue(newValue)
				}
			},
			catchupHours: {
				get() {
					return this.popupData.catchup_hours
				},
				set(newValue) {
					if (newValue === '') {
						this.popupData.catchup_hours = null
					} else {
						this.popupData.catchup_hours = newValue
					}
				}
			},
			timeshift: {
				get() {
					return this.popupData.timeshift
				},
				set(newValue) {
					this.popupData.timeshift = getCorrectBooleanValue(newValue)
				}
			},
			pvr: {
				get() {
					return this.popupData.pvr
				},
				set(newValue) {
					this.popupData.pvr = getCorrectBooleanValue(newValue)
          if(this.popupData.pvr === false){
            this.periodicPvr = false;
          }
				}
			},
      periodicPvr: {
        get() {
          return this.popupData.periodic_pvr
        },
        set(newValue) {
          this.popupData.periodic_pvr = getCorrectBooleanValue(newValue)
        }
      },
		},
		methods: {
			emitAction() {
				if (this.catchup === true && (this.catchupHours === null || isNaN(this.catchupHours) || !Number.isInteger(Number(this.catchupHours)))) {
                    this.setFieldInvalid('popupcatchuphoursref', true, this.$gettext('Zadejte celé kladné číslo'))
                } else if (this.catchup === true && (this.catchupHours === 0 || this.catchupHours === '0')) {
					this.setFieldInvalid('popupcatchuphoursref', true, this.$gettext('Hodnota musí být větší než 0'))
                } else {
					this.setFieldInvalid('popupcatchuphoursref')
					this.$emit('save-settings', this.popupData)
				}
			},
			emitClose() {
				this.$emit('close-popup')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/ServiceSettingsPopup.vue